import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { requerido } from './Validaciones';
import { consultaUsuario } from './ConsultaUser';

export const ConsultaOferta = (id, respuesta) => {
    let Content = { id: id }
    Post(`${Url}consultOferta`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];
        
        for (let i in data) {
            contenido.push({
                id: data[i].id,
                /* codigo: data[i].codigo, */
                seccion: `[${data[i].materia_name}] - ${data[i].nombre}`,
                prof: {value:data[i].profe_id, label:`${data[i].nombre_1} ${data[i].apellido_1}`},
                observ: `${data[i].hora_out} ${data[i].hora_in}`
            })
        }

        respuesta(contenido)
    });
}

export const Oferta = (id, periodo, status, profe, respuesta) => {
    let errores = 0;
    /* Validaciones */
    requerido(errores, periodo.value, "", "", "", "Debes seleccionar un Periodo", (resp) => {
        errores = resp[1];
    });

    if (errores === 0) {
        consultaUsuario ((usu) => {
            let Content = {
                seccion: id,
                periodo: periodo,
                status: status,
                profe: profe
            }

            Post(`${Url}addOferta`, [Content, usu], (resp) => { respuesta(errores) });
        })
    }else{
        respuesta (errores)
    }
}

export const ConsultOferta = (id, respuesta) => {
    let Content = { id: id }

    Post(`${Url}datosOferta`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0][0];
        let chk = false;
        
        let states = "";

        if (data === undefined){
            states = {
                check: chk,
            };
        }else{
            if (data.status === 1) chk = true;

            let meses = (mes) => {
                let mesN = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
                return mesN[mes - 1]
            }
    
            states = {
                check: chk,
                periodoSelect: {value: data.id, label: `${meses(data.corte_name)} ${data.corte_year}`}
            };
        }
        
        respuesta(states)
    });
}

export const ConsultPeriodos = (respuesta) => {
    Post(`${Url}periodos`, "", (resp) => {
        let data = JSON.parse(resp);
        let Contenido= [];

        let meses = (mes) => {
            let mesN = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
            return mesN[mes - 1]
        }

        for (let i in data[0]){
            Contenido.push(
                {value: data[0][i].id, label: `${meses(data[0][i].corte_name)} ${data[0][i].corte_year}`}
            )
        }
        respuesta(Contenido)
    });
}


// WEBPACK FOOTER //
// ./src/funciones/OfertaFunction.jsx